import { memo } from 'react';

import { PublicBoardHeaderCustomFields } from '~/_app/(public-board)/_components/PublicBoardHeaderCustomFields';
import { PublicBoardHeaderDescription } from '~/_app/(public-board)/_components/PublicBoardHeaderDescription';
import { PublicBoardHeaderTitle } from '~/_app/(public-board)/_components/PublicBoardHeaderTitle';
import { PublicBoardMobileShareButton } from '~/_app/(public-board)/_components/PublicBoardMobileShareButton';
import { PublicBoardMoreOptionsButton } from '~/_app/(public-board)/_components/PublicBoardMoreOptionsButton';
import { BoardHeader } from '~/_components/BoardHeader';
import { usePublicPermissions } from '~/components/PublicPermissionsProvider';
import { canSeeAssetCustomFields } from '~/utils/permissions/assetPermissions';

export const PublicBoardHeader = memo(() => {
  const { permissions } = usePublicPermissions();
  const canViewCustomFields = canSeeAssetCustomFields(permissions);

  return (
    <BoardHeader
      actions={
        <>
          <PublicBoardMobileShareButton />
          <PublicBoardMoreOptionsButton />
        </>
      }
      customFields={canViewCustomFields && <PublicBoardHeaderCustomFields />}
      description={<PublicBoardHeaderDescription />}
      title={<PublicBoardHeaderTitle />}
    />
  );
});

PublicBoardHeader.displayName = 'PublicBoardHeader';
